import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function RatingThumbsUp(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Rating Thumbs Up</title>
      <g>
        <path d="M5.85742 52.5H10.8574C12.2324 52.5 13.3574 51.375 13.3574 50V27.5C13.3574 26.125 12.2324 25 10.8574 25H5.85742V52.5ZM55.4324 34.7C55.7074 34.075 55.8574 33.4 55.8574 32.7V30C55.8574 27.25 53.6074 25 50.8574 25H37.1074L39.4074 13.375C39.5324 12.825 39.4574 12.225 39.2074 11.725C38.6324 10.6 37.9074 9.575 37.0074 8.675L35.8574 7.5L19.8324 23.525C18.8824 24.475 18.3574 25.75 18.3574 27.075V46.675C18.3574 49.875 20.9824 52.5 24.2074 52.5H44.4824C46.2324 52.5 47.8824 51.575 48.7824 50.075L55.4324 34.7Z" />
      </g>
    </SvgIcon>
  );
}

export default RatingThumbsUp;
